// Wujie 刷新后的同步值可能包含部署目录，菜单配置则通常是子应用内部路径。
export function normalizeAppMenuRoute(value, projectUrl) {
  if (typeof value !== 'string') return ''
  const pathname = value.split(/[?#]/)[0]
  let base = ''
  try {
    base = new URL(projectUrl || '/', 'https://app.invalid').pathname.replace(/\/$/, '')
  } catch (e) {
    // 无有效部署地址时保留原路径，避免误删其他应用的路径段。
  }
  if (base && (pathname === base || pathname.startsWith(`${base}/`))) {
    return pathname.slice(base.length) || '/'
  }
  return pathname
}

export function matchesAppMenuRoute(value, menuPath, projectUrl) {
  const current = normalizeAppMenuRoute(value, projectUrl)
  const menu = normalizeAppMenuRoute(menuPath, projectUrl)
  return Boolean(current && menu && (current === menu || (menu !== '/' && current.startsWith(`${menu}/`))))
}
